<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage" id="ded01">
<a id="pagev">
<p class="dedicationTextCenter">For the people who experience the most painful suffering, <br/>who feel trapped and hopeless, <br/>who feel life makes no sense and seems utterly cruel—<br/>there is a place in the center of each moment, <br/>available right now, <br/>where freedom and compassionate truth wait <br/>to welcome all of us home.</p>
</a><a id="pagevi">
</a></div><a id="pagevi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781416546375_ded01.vue?dbfeb728